<template>
	<div class="bg-doorsale text-doorsale-text text-sm py-2 text-center">
		{{ $t('doorsale.banner_mode') }}
		<BaseButton type="button" class="underline ml-3 !font-medium !p-0 !text-inherit" :tabindex="-1" @click="closeTab">{{ $t('doorsale.banner_close') }}</BaseButton>
	</div>
</template>

<script setup lang="ts">
	import BaseButton from '@/components/ui/BaseButton.vue';

function closeTab() {
	window.close()
}
</script>
